import { head } from 'ramda';

export const getParentContainer = (element = 'body') =>
	typeof document !== 'undefined' ? (head as any)(document.getElementsByTagName(element)) : null;
